const MAX_ENTRY_NAME_LENGTH = 255;

export default function clampEntryName(name: string): string {
  return name.slice(0, MAX_ENTRY_NAME_LENGTH);
}
